import { css } from 'emotion';

import getFontStyles from '../../../../lib/styles/getFontStyles';
import { LINE_HEIGHT } from '../../../../lib/styles/dynamicStyleConstants';
import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';

function getStyles({ colors, fonts, deviceType }) {
  return {
    bodyWrapper: css({
      backgroundColor: colors.contentBackgroundColor,
    }),
    episodeDescription: css({
      color: colors.contentDescriptionColor,
      '& a': {
        color: colors.contentDescriptionColor,
        textDecoration: 'underline',
        '&:hover, &:active': {
          color: colors.linkColor,
          textDecoration: 'none',
        },
      },
      ...getFontStyles(fonts.contentDescriptionFont, {
        lineHeight: LINE_HEIGHT.EPISODE_PAGE_TEXT,
      }),
      ...{
        [TPADeviceType.MOBILE]: {
          fontSize: 14,
        },
      }[deviceType],
    }),
    episodeMetaInfo: css({
      color: colors.contentDescriptionColor,
      ...getFontStyles(fonts.contentDescriptionFont, {
        lineHeight: LINE_HEIGHT.EPISODE_PAGE_TEXT,
      }),
      ...{
        [TPADeviceType.MOBILE]: {
          fontSize: 16,
        },
      }[deviceType],
    }),
  };
}

export default getStyles;
